<template>
  <div>
    <b-table class="is-middle" :loading="downloads.loading" :data="downloads.data"
      :current-page="downloads.current_page" :per-page="downloads.per_page" :total="downloads.total" paginated
      backend-pagination pagination-position="bottom" @page-change="page => downloads.changePage(page)">
      <template slot-scope="props">
        <b-table-column custom-key="Cover" label="Cover" width="80">
          <img :src="props.row.issue.cover_image_url" style="height: 50px;">
        </b-table-column>

        <b-table-column label="Issue">
          <span>{{ props.row.issue.magazine.name }}</span>
          <span> / </span>
          <span class="has-text-grey">{{ props.row.issue.title }}</span>
        </b-table-column>

        <b-table-column label="Date">
          <div class="has-text-grey">
            <div>{{ props.row.created_at }}</div>
          </div>
        </b-table-column>
      </template>

      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad" size="is-large"></b-icon>
            </p>
            <p>No download list.</p>
          </div>
        </section>
      </template>
    </b-table>


  </div>
</template>

<script>

export default {
  data() {
    return {
      downloads: new window.PaginatedRemoteCollection(
        `/admin/api/users/${this.$route.params.id}/downloads`
      ).load()
    }
  }
};
</script>
